import { extensionsConfig } from "client/config/extensionsConfig";
import { useGoogleDriveUpload } from "client/hooks/upload/useGoogleDriveUpload";
import { List } from "components/common/List/List";
import { DeviceUpload } from "components/common/Upload/DeviceUpload/DeviceUpload";
import { DropboxUpload } from "components/common/Upload/DropboxUpload/DropboxUpload";
import { GoogleDriveAccessErrorModal } from "components/common/Upload/GoogleDriveUpload/GoogleDriveAccessErrorModal/GoogleDriveAccessErrorModal";
import { GoogleDriveUpload } from "components/common/Upload/GoogleDriveUpload/GoogleDriveUpload";
import { UrlUpload } from "components/common/Upload/UrlUpload/UrlUpload";
import { useAddImages } from "../../../ControlBar/AddImages/useAddImages";

export interface AddImageProps {
    handleClose: () => void;
    isOpen: boolean;
}

const supportedExtensions = extensionsConfig["image-compressor"];

export const AddImage = ({ handleClose, isOpen }: AddImageProps) => {
    const { handleFile } = useAddImages(handleClose);
    const {
        handleClick: handleGoogleDriveUploadClick,
        accessError,
        setAccessError,
        isLoading: isGoogleDriveLoading,
    } = useGoogleDriveUpload(handleFile, { allowMultiple: true, supportedExtensions }, isOpen);

    return (
        <div className="relative flex flex-col gap-3 py-2 font-xl">
            <GoogleDriveAccessErrorModal
                isOpen={accessError}
                close={() => setAccessError(false)}
                handleRetry={handleGoogleDriveUploadClick}
            />
            <List
                items={{
                    from_device: (
                        <DeviceUpload
                            handleFile={handleFile}
                            options={{ allowMultiple: true, supportedExtensions }}
                            htmlFileInputId="compressor-mobile-file-input"
                        />
                    ),
                    dropbox: (
                        <DropboxUpload
                            handleFile={handleFile}
                            options={{ allowMultiple: true, supportedExtensions }}
                            isOpen={isOpen}
                        />
                    ),
                    google_drive: (
                        <GoogleDriveUpload
                            options={{
                                allowMultiple: true,
                                onClick: () => handleGoogleDriveUploadClick(),
                                supportedExtensions,
                            }}
                            isLoading={isGoogleDriveLoading}
                        />
                    ),
                    url_upload: <UrlUpload handleFile={handleFile} options={{ supportedExtensions }} />,
                }}
            />
        </div>
    );
};
